import { KTestConfig, KTestFunction, YupSchema } from 'services/yup/types'
import {
  APILinkedIfClauseRule,
  APILinkedThenClauseRule,
} from 'services/api/entities/catalog/types'
import { yupArray } from 'services/yup/custom-schemas/array'
import { productCommonVS } from './productCommon'
import { yupString } from 'services/yup/custom-schemas/string'
import { RuleAction } from 'services/api/entities/Rules'
import { yupIgnore, yupObject } from 'services/yup'
import { tailoredProductVS } from './tailoredProduct'
import {
  Highlight,
  MainProduct,
} from 'services/api/entities/catalog/mainProduct/types/internal/mainProduct-models'
// import kampaayDataProvider from 'services/api/dataProvider'
// import { getDefaultListParams } from 'services/utils'
// import { ServicesConfig } from 'services/api/entities/servicesconfig'

const timeLimitValidation: KTestFunction<number> = async (timeLimit, k) => {
  // const servicesConfig = (
  //   await kampaayDataProvider.getList<ServicesConfig>(
  //     'servicesconfig',
  //     getDefaultListParams()
  //   )
  // ).data[0]

  // console.log('aaa', timeLimit, servicesConfig, k)

  // const { advanceReservationMin } =
  //   servicesConfig[COLLECTION_NAME_SERVICE_MAP['drinks']]
  return true
}

const isTimeLimitGreaterThenTheOneInCFG: KTestConfig<number> = {
  test: timeLimitValidation,
  message: () => 'error',
}

const ifClauseLinkedRulesVS: YupSchema<APILinkedIfClauseRule> =
  yupObject().shape({
    ruleName: yupString(),
  })

const thenClauseLinkedRulesVS: YupSchema<APILinkedThenClauseRule> =
  yupObject().shape({
    ruleName: yupString(),
    action: yupString<RuleAction>(),
    ruleServicesWhere: yupArray(),
  })

const highLightVS: YupSchema<Highlight> = yupObject().shape({
  preview: yupString(),
  content: yupString(),
})

export const mainProductVS: YupSchema<MainProduct> = productCommonVS
  .concat(tailoredProductVS)
  .shape({
    ifClauseLinkedRules: yupArray(ifClauseLinkedRulesVS),
    thenClauseLinkedRules: yupArray(thenClauseLinkedRulesVS),
    sections: yupArray(),
    highlights: yupArray(highLightVS),
    advanceReservationMin: yupIgnore<number>().test(
      isTimeLimitGreaterThenTheOneInCFG
    ),
  })
